import { render, staticRenderFns } from "./ProcessingPersonnel.vue?vue&type=template&id=05fc33a9&scoped=true"
import script from "./ProcessingPersonnel.vue?vue&type=script&lang=js"
export * from "./ProcessingPersonnel.vue?vue&type=script&lang=js"
import style0 from "./ProcessingPersonnel.vue?vue&type=style&index=0&id=05fc33a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc33a9",
  null
  
)

export default component.exports